// frontend/shared-ui/src/components/Modal.jsx
import React, { useEffect } from "react";

export default function Modal({
  open,
  title,
  onClose,
  children,
  footer,
  size = "md",
  closeOnBackdrop = true,
}) {
  useEffect(() => {
    if (!open) return;

    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);

    // Lock background scroll while modal is open
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <>
      <div
        className="fh-modal-backdrop"
        onClick={() => closeOnBackdrop && onClose?.()}
      />
      <div
        className="fh-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? "fh-modal-title" : undefined}
      >
        <div
          className={`fh-modal__dialog fh-modal__dialog--${size}`}
          onClick={(e) => e.stopPropagation()}
        >
          {(title || onClose) && (
            <div className="fh-modal__header">
              <h5 id="fh-modal-title" className="fh-modal__title">
                {title}
              </h5>
              {onClose && (
                <button
                  type="button"
                  className="fh-modal__close"
                  onClick={onClose}
                  aria-label="Close"
                >
                  ×
                </button>
              )}
            </div>
          )}
          <div className="fh-modal__body">{children}</div>
          {footer && <div className="fh-modal__footer">{footer}</div>}
        </div>
      </div>
    </>
  );
}
